import Button from 'devextreme-react/button';
import ScrollView from 'devextreme-react/scroll-view';
import { signoutUrl } from '../../api/auth';

/** Shown when Entra sign-in succeeded but the user has no Ops App Role assignment. */
export function AccessDeniedPage() {
  return (
    <ScrollView>
      <div style={{ padding: '2rem', maxWidth: 560 }}>
        <h2>Access denied</h2>
        <p>
          Your account signed in, but it is not assigned an <strong>Ops</strong> role on the WebOps enterprise
          application. Ask an administrator to grant <strong>ItSysAdmin</strong>, <strong>OpsPharmacy</strong>,{' '}
          <strong>OpsHRCompany</strong>, <strong>OpsHRContract</strong>, or <strong>OpsSales</strong> in Entra ID.
        </p>
        <Button
          text="Sign out"
          type="danger"
          stylingMode="contained"
          onClick={() => {
            window.location.assign(signoutUrl());
          }}
        />
      </div>
    </ScrollView>
  );
}
